import React, { FC } from 'react'
import ActionData from '../../../types/ActionData'
import CurrentUser from '../../../types/User'
import User from '../../../types/UserList'
import { Modal, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CircularProgress from '@material-ui/core/CircularProgress'
import UserData from '../../UserAccount/UserData'
import './index.css'

interface Props {
  addedUser: string;
  addUser: ActionData;
  changingUser: boolean;
  disableAddButton: boolean;
  duplicateEmail: boolean;
  emailError: boolean;
  emailProvider: string;
  firstNameProvider: string;
  lastNameProvider: string;
  modalType: string;
  organizationOptions: any;
  providerOptions: any;
  roleOptions: any;
  updateUser: ActionData;
  user: CurrentUser;
  width: number;
  selectedEnabledData: boolean;
  selectedProvider: any;
  selectedOrganization: any;
  selectedRole: any;
  selectedUser?: User;
  show: boolean;
  onClose: () => void;
  onChangeEnabledData: () => void;
  onClickEdit: () => void;
  onChangeOrganizationData: (selected: any) => void;
  onChangeProviderData: (selected: any) => void;
  onChangeProviderFields: (e: any, name: string) => void;
  onChangeRoleData: (selected: any) => void;
  onClickAdd: () => void;
}

const UserModal: FC<Props> = (props: Props) => {
  const { addUser, addedUser, changingUser, disableAddButton, duplicateEmail, emailError, emailProvider, firstNameProvider, lastNameProvider, modalType, organizationOptions, providerOptions, roleOptions, selectedEnabledData, selectedUser, selectedOrganization, selectedProvider, selectedRole, show, updateUser, user, width, onClose, onChangeEnabledData, onChangeOrganizationData, onChangeProviderData, onChangeProviderFields, onChangeRoleData, onClickAdd, onClickEdit } = props

  let buttonName = 'Add User'
  let modalTitle = 'Add a Provider Admin'

  if (modalType === 'edit') {
    buttonName = 'Save'
    modalTitle = 'View / Edit Provider Admin'
  }

  let loadingIcon = <CircularProgress size={70} />
  let modalText = 'Saving data'
	
  if(addUser.error!== false){
	  loadingIcon = <FontAwesomeIcon icon={['fas', 'exclamation-circle']} color="#cb6767" className="modal-success-icon" />
	  modalText = 'The user could not be saved.'
  }

  if (updateUser.error !== false) {
    loadingIcon = <FontAwesomeIcon icon={['fas', 'exclamation-circle']} color="#cb6767" className="modal-success-icon" />
    modalText = `The user could not be saved. ${updateUser.error.response.text}`
  }

  const disableButton = () => {
    if ((selectedRole.value === 4 && selectedProvider.length > 0 && disableAddButton === false) || (selectedRole.value === 5 && selectedOrganization.length > 0 && disableAddButton === false)) {
      return false
    } else {
      return true
    }
  }

  return (
    <Modal size="xl" show={show} onHide={onClose}>
      <Modal.Header closeButton id="modal-header">
        <FontAwesomeIcon icon={['fas', 'user-circle']} size="lg" className="modal-header-icon" />
        <Modal.Title id="modal-header-title">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {changingUser ? (
          addUser.loading || addUser.error !== false || updateUser.loading || updateUser.error !== false ? (
            <div className="modal-loading-container">
              {loadingIcon}
              <span className="modal-loading-text">{modalText}</span>
            </div>
          ) : addUser.success || updateUser.success ? (
            <div>
              <div className="modal-success-container">
                <FontAwesomeIcon icon={['far', 'check-circle']} color="#75b465" className="modal-success-icon" />
                <span className="modal-success-text">{addedUser} has been {modalType === 'edit' ? 'Updated' : 'sent an email to validate their address and set their password.'}</span>
              </div>
              <div className="modal-button-grp">
                <Button variant="secondary" id="modal-cancel-btn" onClick={onClose}>
                  Close
                </Button>
                <Button id="modal-view-btn" onClick={onClickEdit}>
                  View User
                </Button>
              </div>
            </div>
          ) : (
            <div></div>
          )
        ) : (
          <div>
            <div className="custom-modal-body">
              {modalType === 'edit' ? (
                <div></div>
              ) : (
                <div>
                  <span className="modal-warning-text"><FontAwesomeIcon icon={['fas', 'info-circle']} className="modal-warning-icon" />All fields required unless otherwise noted.</span>
                  <hr />
                </div>
              )}
              <UserData
                isLoggedUser={selectedUser !== undefined ? selectedUser.user_id === user.user_id : false}
                duplicateEmail={duplicateEmail}
                emailError={emailError}
                emailProvider={emailProvider}
                firstNameProvider={firstNameProvider}
                lastNameProvider={lastNameProvider}
                organizationOptions={organizationOptions}
                providerOptions={providerOptions}
                roleOptions={roleOptions}
                selectedEnabledData={selectedEnabledData}
                selectedProvider={selectedProvider}
                selectedOrganization={selectedOrganization}
                selectedRole={selectedRole}
                type={modalType}
                user={selectedUser}
                viewOnly={false}
                width={width}
                onChangeEnabledData={onChangeEnabledData}
                onChangeOrganizationData={onChangeOrganizationData}
                onChangeProviderData={onChangeProviderData}
                onChangeProviderFields={(e: any, name: string) => { onChangeProviderFields(e, name) }}
                onChangeRoleData={onChangeRoleData}
              />
            </div>
            <div className="modal-button-grp">
              <Button variant="secondary" id="modal-cancel-btn" onClick={onClose}>
                Cancel
              </Button>
              <Button id="modal-add-btn" disabled={disableButton()} onClick={onClickAdd}>
                {buttonName}
              </Button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default UserModal